import { effect, inject, Injectable, signal } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { LanguageFacade } from '@core/language/facades/language.facade';
import { ConfigurationService } from '@kaseya-design-components';
import { kdsTranslations } from '@core/translation/models/kds-translations/kds-translations';

@Injectable({
  providedIn: 'root',
})
export class TranslationFacade {
  private readonly languageFacade = inject(LanguageFacade);
  private readonly configurationService = inject(ConfigurationService);
  private readonly translateServices = signal<TranslateService[]>([]);

  constructor() {
    this.applyTranslations();
  }

  addTranslateService(translateService: TranslateService): void {
    this.translateServices.update(translateServices => translateServices.concat(translateService));
  }

  private applyTranslations(): void {
    effect(() => {
      const language = this.languageFacade.language();
      this.configurationService.setTranslation(kdsTranslations[language]);
      this.translateServices().forEach(translateService => {
        translateService.use(language);
      });
    });
  }
}
